var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "department-user-row",
      class: { "blur-row": !_vm.isDepartmentActive },
    },
    [
      _c("div", { staticClass: "target-cell" }, [
        _c("div", { staticClass: "target-info" }, [
          _c("div", { staticClass: "indent" }),
          _vm._v(" "),
          _c("i", { staticClass: "material-icons user-icon" }, [
            _vm._v("person"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "target-name" }, [
            _vm._v(_vm._s(_vm.user.name)),
          ]),
          _vm._v(" "),
          _vm.hasUserOverride
            ? _c("span", { staticClass: "override-badge" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("verified_user"),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("table.specialPermission")) +
                    "\n            "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.scopeGroups, function (group) {
        return _c("div", { key: group.id, staticClass: "scope-group-cell" }, [
          _c(
            "div",
            { staticClass: "scope-toggles" },
            _vm._l(group.scopes, function (scope) {
              return _c(
                "div",
                {
                  key: scope,
                  staticClass: "scope-toggle-cell",
                  class: {
                    "from-department":
                      _vm.hasScopeFromDepartment(scope) &&
                      !_vm.hasUserOverride &&
                      _vm.isDepartmentActive,
                    "from-user": _vm.hasScopeFromUser(scope),
                    "user-override-active": _vm.hasUserOverride,
                  },
                },
                [
                  _c("div", { staticClass: "scope-indicator" }, [
                    _vm.hasMergedScope(scope)
                      ? _c("i", { staticClass: "material-icons" }, [
                          _vm._v("done"),
                        ])
                      : _c("i", { staticClass: "material-icons" }, [
                          _vm._v("circle"),
                        ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }